import { makeStyles } from "@material-ui/core";
import CloseIcon from "@mui/icons-material/Close";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { TabContext, TabList, TabPanel } from "@mui/lab";
import {
  Box,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Divider,
  IconButton,
  Stack,
  Tab,
  TextField,
  Tooltip,
  Typography,
} from "@mui/material";
import Autocomplete, { createFilterOptions } from "@mui/material/Autocomplete";
import CircularProgress from "@mui/material/CircularProgress";
import Grid from "@mui/material/Grid";
import axios from "axios";
import b64toBlob from "b64-to-blob";
import isoCountries from "i18n-iso-countries";
import jwt_decode from "jwt-decode";
import moment from "moment";
import React, { useContext, useEffect, useState } from "react";
import { useDymoCheckService, useDymoFetchPrinters } from "react-dymo-hooks";
import { useTranslation } from "react-i18next";
import "react-phone-input-2/lib/style.css";
import { useDispatch } from "react-redux";
import cameraIcon from "../../assets/cameraIcon.svg";
import errorIcon from "../../assets/USA_Images/offenderError.svg";
import successIcon from "../../assets/USA_Images/offenderSuccess.svg";
import CustomDateTimePicker from "../../components/CustomInputs/CustomDateTimePicker";
import CustomTextfield from "../../components/CustomInputs/CustomTextfield";
import { WebcamCapture } from "../../components/CustomInputs/WebCam";
import CancelButtons from "../../components/DialogBoxComponent/CancelButtons";
import SubmitButtons from "../../components/DialogBoxComponent/SubmitButtons";
import VisitorAssetsDialog from "../../components/DialogBoxComponent/VisitorAssetsDialog";
import ProfileContext from "../../components/ProfileContext";
import Toast from "../../components/ToastContainer/CustomToast";
import httpCommon from "../../config/http-common";
import "../../Pages/Registrations/phoneInput.css";
import { getListSettings } from "../../slices/AdditionalSettings/AdditionalSettingsSlice";
import { getCompanyInfo } from "../../slices/Company/CompanySlice";
import { getEmployeeNotificationDetails } from "../../slices/Employee/EmployeeSlice";
import {
  rejectVisitorPreRegistrationInvite,
  updatePreRegistration,
} from "../../slices/Invitations/InvitationsSlice";
import { getPurposeType } from "../../slices/PurposeTypeGlobalUSA/PurposeTypeGlobalSlice";
import { getAllSites } from "../../slices/Site/SiteSlice";
import { customerSubscription } from "../../slices/Subscription/SubscriptionSlice";
import { getUserInfoPro } from "../../slices/User/UserSlice1";
import {
  deteleAssetImage,
  uploadVisitorAsset,
  validateVisitorImage,
} from "../../slices/VisitorDocuments/VisitorDocumentSlice";
import { getAllVisitorType } from "../../slices/VisitorType/VisitorTypeSlice";
import { ThemeContext } from "../../theme/ThemeContext";
import CommonUtil from "../../Util/CommonUtils";
import CustomPhones from "../OnBoardV2/CustomPhones";
import Offender from "../Registrations/Offender";
import UploadDocs from "../Registrations/UploadDocs";

const Dymo = require("dymojs"),
  dymo = new Dymo();

const useStyles = makeStyles((theme) => ({
  dialogbox: {
    "& .css-ypiqx9-MuiDialogContent-root": {
      padding: "0px !important",
    },
  },
  input: {
    "&:-webkit-autofill": {
      WebkitTextFillColor: "#000 !important",
    },
  },
}));

export default function PreRegistrationEditDialog(props) {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const { open, rowData } = props;
  const [siteData, setSiteData] = useState([]);
  const [hostList, setHostList] = useState([]);
  const [selectedHost, setSelectHost] = useState({});
  const classes = useStyles();
  const [InavalidprofilePhoto, setInavalidprofilePhoto] = useState(false);
  const [visitorData, setVisitorData] = useState([]);
  const [purposeData, setPurposeData] = useState([]);
  const [phoneInput, setPhoneInput] = useState("");
  const [profileImage, setProfileImage] = useState();
  const [printerImage, setPrinterImage] = useState("");
  const [documentScanMode, setDocumentScanMode] = useState("");
  const [dlImage, setdlImage] = useState();
  const [changeDate, setDateChange] = useState(true);
  const [userPhone, setUserPhone] = useState("");
  const { setCurrentTotalVisitCount } = useContext(ProfileContext);
  const [dlScannerPermission, setDlScannerPermission] = useState(false);
  const [featureList, setFeatureList] = useState([]);
  const [webCam, setWebCam] = useState(false);
  const [assetuploadData, setAssetUploadData] = useState({});
  const [assetsImages, setAssetsImages] = useState([]);
  const [country, setCountry] = useState("");
  const [hoveredIndex, setHoveredIndex] = useState(null);
  const [objectKeys, setObjectKeys] = useState([]);
  const [walkInImageCapture, setWalkInImageCapture] = useState(false);
  const [loading, setLoading] = useState(false);
  const [offenderFeature, setOffenderFeature] = useState(false);
  const { darkMode } = useContext(ThemeContext);
  const companySettings = JSON.parse(localStorage.getItem("companySettings"));
  const [searchTerm, setSearchTerm] = useState("");
  const [offenderVerification, setOffenderVerification] = useState(
    companySettings.offenderVerification,
  );
  const [documentCapturePermission, setDocumentCapturePersmission] = useState(
    companySettings.documentCapture,
  );
  const [siteTimeEnable, setSiteTimeEnable] = useState(true);
  const intervalSetting =
    props.walkInIntervalTime ?? companySettings.walkInIntervalTime;
  const walkInIntervalTime =
    intervalSetting === "" ||
    intervalSetting === null ||
    intervalSetting === undefined ||
    isNaN(Number(intervalSetting))
      ? 30
      : Number(intervalSetting);
  const [
    isDrivingLicenseEnabledForAdmin,
    setIsDrivingLicenseEnabledForAdmin,
  ] = useState(false);
  const [offender, setOffender] = useState(false);
  var decoded_jwtToken = jwt_decode(
    localStorage.getItem(process.env.REACT_APP_ACCESS_TOKEN),
  );
  const [offenderDataList, setOffenderDataList] = useState([]);
  const [dateFormat, setDateFormat] = useState(null);
  // Difference between the site's clock and this PC's clock (ms). All schedule
  // times in this dialog are site wall-clock times, never the PC's time zone.
  const [siteClockOffsetMs, setSiteClockOffsetMs] = useState(0);

  // Current date/time at the site (as a wall-clock Date)
  const getSiteNow = () => new Date(Date.now() + siteClockOffsetMs);

  // UTC value from the API -> site wall-clock time (uses the visit's site offset)
  const toSiteWallClock = (utcValue) => {
    const utc = moment.utc(utcValue);
    if (!rowData?.siteTimeZone) return utc.local();
    return moment(
      utc
        .clone()
        .utcOffset(rowData.siteTimeZone)
        .format("YYYY-MM-DDTHH:mm:ss"),
    );
  };
  var today = new Date();

  useEffect(() => {
    loadPersonPermission();
  }, []);

  const loadPersonPermission = () => {
    dispatch(getEmployeeNotificationDetails())
      .unwrap()
      .then((res) => {
        if (res.code === "MSGS4016") {
          setIsDrivingLicenseEnabledForAdmin(
            res.data.drivingLicenseEnabledForAdmin,
          );
        }
      });
  };

  useEffect(() => {
    let payload = {
      companyId: decoded_jwtToken.companyId,
    };
    if (decoded_jwtToken.companyType === "CUSTOMER") {
      dispatch(customerSubscription(payload))
        .unwrap()
        .then((res) => {
          if (res.code === "MSGS4032" && res.data) {
            const featureNames = res.data.data.feature.map(
              (feature) => feature.name,
            );
            setFeatureList(featureNames);
          }
        });
    }
  }, []);

  useEffect(() => {
    const normalizedFeatureList = featureList.map((feature) => {
      if (feature === "Checklist") {
        return "Checklist";
      }
      if (feature === "Watchlist") {
        return "Watchlist";
      }
      if (feature === "Offender Verification") {
        return "Offender";
      }
      if (
        feature === "Walk-In Registration through DL & Passport Scanner on Web"
      ) {
        return "Walk-In Registration";
      }
      return feature;
    });
    if (normalizedFeatureList.length !== 0) {
      normalizedFeatureList.forEach((item) => {
        if (
          item === "Walk-In Registration" &&
          isDrivingLicenseEnabledForAdmin &&
          decoded_jwtToken.roleCode === "ADMIN"
        ) {
          setValue("scanLicense");
          setDlScannerPermission(true);
        } else if (
          item === "Walk-In Registration" &&
          decoded_jwtToken.roleCode !== "ADMIN"
        ) {
          setValue("scanLicense");
          setDlScannerPermission(true);
        }
        if (item === "Offender") {
          setOffenderFeature(true);
          setOffender(true);
        }
      });
    }
  }, [featureList]);

  const formatDayAndMonth = (numValue) => {
    if (numValue <= 0) {
      return "-" + (numValue + 12);
    }
    if (numValue < 10) {
      return "-0" + numValue;
    } else {
      return "-" + numValue;
    }
  };

  var startDate =
    today.getFullYear() +
    formatDayAndMonth(today.getMonth() + 1) +
    formatDayAndMonth(today.getDate()) +
    "T" +
    (today.getHours() < 10 ? "0" + today.getHours() : today.getHours()) +
    ":" +
    (today.getMinutes() < 10 ? "0" + today.getMinutes() : today.getMinutes());

  const [payload, setPayload] = useState({
    firstName: "",
    lastName: "",
    emailId: "",
    phoneNumber: "",
    phoneCountryCode: "",
    purposeTypeId: "",
    visitorTypeId: "",
    hostId: "",
    visitorCompanyName: "",
    siteId: "",
    scheduledStartDate: "",
    scheduledEndDate: "",
    visitMode: "PRE_REGISTRATION",
    profilePhoto: "",
    documentNumber: "",
    documentExpireDate: "",
    documentFrontImage: "",
    documentRearImage: "",
    verifyTypeIn: "",
    walkInScan: "",
    invitationScan: "",
    selfScan: "",
    address: "",
    remarks: "",
    approvalReason: "",
    printerImage: "",
    documentIssuedDate: "",
    documentScanMode: documentScanMode,
    dateOfBirth: "",
    offenderMatch: false,
  });

  // Same API as walk-in: the site's current date/time, used as "now" for all checks
  const loadSiteCurrentTime = (siteId) => {
    if (!siteId) return;
    httpCommon
      .securedAxios()
      .get(`/web/visit/site/${siteId}/currectDateTime`)
      .then((response) => {
        const siteCurrentTime = response?.data?.data?.siteCurrentTime;
        if (response?.data?.code === "CVAI0000" && siteCurrentTime) {
          setSiteClockOffsetMs(
            new Date(siteCurrentTime).getTime() - Date.now(),
          );
        }
      })
      .catch((error) => console.log(error));
  };

  useEffect(() => {
    if (!open || !rowData) return;

    let phoneCountryCode = "";
    let phoneNumber = "";
    if (rowData.visitor?.phone) {
      const phoneParts = rowData.visitor.phone.replace(/^\+/, "").split("-");
      phoneCountryCode = "+" + phoneParts[0];
      phoneNumber = phoneParts.slice(1).join("-");
      setPhoneInput((phoneCountryCode + phoneNumber).replace(/[+-]/g, ""));
    } else {
      setPhoneInput("");
    }

    setPayload((prev) => ({
      ...prev,
      firstName: rowData.visitor?.firstName || "",
      lastName: rowData.visitor?.lastName || "",
      emailId: "",
      phoneCountryCode,
      phoneNumber,
      visitorCompanyName: "",
      hostId: rowData.hostId || "",
      siteId: rowData.siteId,
      siteTimeZone: "",
      purposeTypeId: "",
      visitorTypeId: "",
      remarks: rowData.remarks || "",
      approvalReason: rowData.approvalReason || rowData.remarks || "",
      scheduledStartDate: rowData.scheduledStartDate
        ? CommonUtil.formatLocalDateTime(
            toSiteWallClock(rowData.scheduledStartDate),
          )
        : "",
      scheduledEndDate: rowData.scheduledEndDate
        ? CommonUtil.formatLocalDateTime(
            toSiteWallClock(rowData.scheduledEndDate),
          )
        : "",
    }));
    setSiteTimeEnable(false);
    loadSiteCurrentTime(rowData.siteId);
    setError({
      firstName: false,
      lastName: false,
      emailId: false,
      phoneNumber: false,
      siteId: false,
      hostId: false,
      selectedHost: false,
      purposeTypeId: false,
      visitorTypeId: false,
      visitorCompanyName: false,
      scheduledStartDate: false,
      scheduledEndDate: false,
    });

    // if (rowData.allowedCheckInTime) {
    //   const allowedCheckInTime = moment.utc(rowData.allowedCheckInTime).local();
    //   if (moment().isBefore(allowedCheckInTime)) {
    //     Toast(t("CHECKIN_NOT_ALLOWED_BEFORE_START"), "error");
    //   }
    // }
  }, [open, rowData]);

  useEffect(() => {
    if (!open || !rowData?.siteId || CommonUtil.isEmptyArray(siteData)) {
      return;
    }
    const matchedSite = siteData.find((site) => site.id === rowData.siteId);
    if (matchedSite) {
      setPayload((prev) => ({
        ...prev,
        siteId: matchedSite,
        siteTimeZone: matchedSite.timeZone || "",
      }));
    }
  }, [open, rowData, siteData]);

  useEffect(() => {
    if (!open || !rowData?.hostId || CommonUtil.isEmptyArray(hostList)) {
      return;
    }
    const matchedHost = hostList.find((host) => host.id === rowData.hostId);
    if (matchedHost) {
      setSelectHost(matchedHost);
      setPayload((prev) => ({ ...prev, hostId: matchedHost.id }));
    }
  }, [open, rowData, hostList]);

  useEffect(() => {
    if (
      !open ||
      !rowData?.purposeType?.id ||
      CommonUtil.isEmptyArray(purposeData)
    ) {
      return;
    }
    const matchedPurposeType = purposeData.find(
      (purposeType) => purposeType.id === rowData.purposeType.id,
    );
    if (matchedPurposeType) {
      setPayload((prev) => ({ ...prev, purposeTypeId: matchedPurposeType }));
    }
  }, [open, rowData, purposeData]);

  useEffect(() => {
    if (
      !open ||
      !rowData?.visitorType?.id ||
      CommonUtil.isEmptyArray(visitorData)
    ) {
      return;
    }
    const matchedVisitorType = visitorData.find(
      (visitorType) => visitorType.id === rowData.visitorType.id,
    );
    if (matchedVisitorType) {
      setPayload((prev) => ({ ...prev, visitorTypeId: matchedVisitorType }));
    }
  }, [open, rowData, visitorData]);

  const [offenderData, setOffenderData] = useState({
    name: "",
    firstName: "",
    firstNameNicknames: [],
    middleName: "",
    lastName: "",
    dob: "",
    address: "",
    city: "",
    state: "",
    zipcode: "",
    sex: "",
    age: "",
    eyeColor: "",
    hairColor: "",
    height: "",
    weight: "",
    race: "",
    ethnicity: "",
    marks: "",
    riskLevel: "",
    crime: "",
    registrationDate: "",
    content: "",
    lat: 0,
    lng: 0,
    offenderUrl: "",
    offenderImageUrl: "",
    offenderImageUrlR2: "",
    jurisdiction: "",
    isAbsconder: false,
    isPredator: false,
    updatedAt: "",
    createdAt: "",
    uuid: "",
    sources: [],
  });

  const [error, setError] = useState({
    firstName: false,
    lastName: false,
    emailId: false,
    phoneNumber: false,
    purposeTypeId: false,
    visitorTypeId: false,
    hostId: false,
    visitorCompanyName: false,
    siteId: false,
    profilePhoto: false,
    documentNumber: false,
    documentExpireDate: false,
    approvalReason: false,
    remarks: false,
  });

  const statusDymoService = useDymoCheckService();

  const { statusFetchPrinters, printers } = useDymoFetchPrinters(
    statusDymoService,
  );

  const print = (data) => {
    console.log("Checking connected printers:", printers);

    if (!Array.isArray(printers) || printers.length === 0) {
      return;
    }
    printers.forEach((printer) => {
      try {
        dymo.print(printer.name, data);
        console.log(`Print job sent to ${printer.name}`);
      } catch (error) {
        console.error(`Print failed for ${printer.name}:`, error);
      }
    });
  };

  const onError = (data) => {
    if (data)
      switch (data.code) {
        case "CVAE1015":
          setError({ emailId: true });
          break;
        case "CVAE1016":
          setError({ emailId: true });
          break;
        case "CVAE1012":
          setError({ firstName: true });
          break;
        case "CVAE1013":
          setError({ firstName: true });
          break;
        case "CVAE1017":
          setError({ phoneNumber: true });
          break;
        case "CVAE1050":
          setError({ visitorTypeId: true });
          break;
        case "CVAE1041":
          setError({ purposeTypeId: true });
          break;
        case "CVAE1051":
          setError({ visitorCompanyName: true });
          break;
        case "CVAE1019":
          setError({ hostId: true });
          break;
        case "CVAE1021":
        case "CVAE1053": // start time less than current time
        case "CVAE1054": // check-in not allowed before scheduled start
        case "CVAE1055": // changed start time too far ahead
          setError({ scheduledStartDate: true });
          break;
        case "CVAE1022":
          setError({ scheduledEndDate: true });
          break;
        case "CVAE1023":
          setError({ scheduledEndDate: true });
          break;
        case "CVAE0300":
          setError({ siteId: true });
          break;
        default:
          setError({ ...error });
      }
    Toast(data.message, "error");
  };

  const uploadProfilePhoto = (data) => {
    var bodyFormData = new FormData();
    bodyFormData.append("url", data.data.profilePhotoURL);
    if (documentScanMode) {
      bodyFormData.append("file", dlImage);
    } else {
      bodyFormData.append("file", profileImage);
    }
    axios({
      method: "post",
      url: "/web/employee/profile",
      data: bodyFormData,
      Authorization: localStorage.getItem("VISJwtToken"),
      headers: { "Content-Type": "multipart/form-data" },
    })
      .then(function(response) {})
      .catch(function(response) {});
  };

  const uploadAssetImages = (data) => {
    var bodyFormData = new FormData();
    bodyFormData.append("url", assetuploadData.preSignedURL);
    bodyFormData.append("file", data);

    axios({
      method: "post",
      url: "/web/employee/profile",
      data: bodyFormData,
      Authorization: localStorage.getItem("VISJwtToken"),
      headers: { "Content-Type": "multipart/form-data" },
    })
      .then(function(response) {})
      .catch(function(response) {});
  };

  const handleClose = (data) => {
    clearData();
    props.onClose();
    if (data.type) {
      handleDeleteAssets();
    }
  };

  const handleDeleteAssets = () => {
    let payload = {
      fileName: "",
      scope: "",
      applicationName: "",
      companyId: "",
      objectKeys: objectKeys,
    };
    dispatch(deteleAssetImage(payload))
      .unwrap()
      .then((res) => {
        if (res.code === "MSGS4043") {
        } else {
          Toast(res.message, "error");
        }
      });
  };

  const handleSubmit = () => {
    if (!InavalidprofilePhoto) {
      if (profilePhotoMandatory) {
        if (profileImage === undefined || profileImage === "") {
          Toast(t("PROFILE_PHOTO"), "error");
          setError({ profilePhoto: true });
          return;
        }
      }

      if (CommonUtil.isEmptyString(payload.firstName)) {
        Toast(t("USERPROFSCREEN007"), "error");
        setError({ firstName: true });
        return;
      }

      if (!CommonUtil.isValidNames(payload.firstName)) {
        Toast(t("WALKINREPORTLBL2"), "error");
        setError({ firstName: true });
        return;
      }

      if (
        CommonUtil.isEmptyString(payload.emailId) &&
        CommonUtil.isEmptyString(payload.phoneNumber)
      ) {
        Toast(t("USERPROFSCREEN014"), "error");
        setError({ emailId: true });
        return;
      }
      if (
        decoded_jwtToken.email === payload.emailId.trim() ||
        payload.emailId.trim() === selectedHost.email
      ) {
        setError({ emailId: true });
        Toast(t("INVITATIONFORM006"), "error");
        return;
      }

      if (
        payload.phoneNumber !== null &&
        payload.phoneNumber !== undefined &&
        payload.phoneNumber !== ""
      ) {
        if (
          userPhone === payload.phoneCountryCode + "-" + payload.phoneNumber ||
          payload.phoneCountryCode + "-" + payload.phoneNumber ===
            selectedHost.phone
        ) {
          setError({ phoneNumber: false });
          Toast(t("INVITATIONFORM009"), "error");
          return;
        }
      }

      if (CommonUtil.isEmpty(selectedHost)) {
        Toast(t("INVITATIONFORM007"), "error");
        setError({ selectedHost: true });
        return;
      }

      if (CommonUtil.isEmpty(payload.siteId)) {
        Toast(t("Site is mandatory"), "error");
        setError({ selectedHost: true });
        return;
      }

      if (
        payload.scheduledStartDate === null ||
        payload.scheduledStartDate === undefined ||
        payload.scheduledStartDate === ""
      ) {
        setError({ scheduledStartDate: true });
        Toast(t("INVITATIONFORM011"), "error");
        return;
      }

      if (
        payload.scheduledEndDate === null ||
        payload.scheduledEndDate === undefined ||
        payload.scheduledEndDate === ""
      ) {
        setError({ scheduledEndDate: true });
        Toast(t("INVITATIONFORM012"), "error");
        return;
      }

      if (scannedDocument) {
        if (payload.documentNumber === "") {
          Toast(t("ENTER_DL_NUMBER"), "error");
          return;
        }
        // if (payload.documentIssuedDate === "") {
        //   Toast(t("ENTER_DL_ISSUE_DATE"), "error");
        //   return;
        // }

        if (payload.documentExpireDate === "") {
          Toast(t("ENTER__DL_EXPIRATION_DATE"), "error");
          return;
        }
        if (
          !passport &&
          payload.documentFrontImage === "" &&
          documentCapturePermission
        ) {
          Toast(t("ENTER_FRONT_IMAGE"), "error");
          return;
        }
        if (
          !passport &&
          payload.documentRearImage === "" &&
          documentCapturePermission
        ) {
          Toast(t("ENTER_REAR_IMAGE"), "error");
          return;
        }
        if (profilePhotoMandatory) {
          if (dlImage === "") {
            Toast(t("PROFILE_PHOTO"), "error");
            return;
          }
        }
      }

      if (
        new Date(payload.scheduledStartDate) <
        new Date(payload.scheduledEndDate)
      ) {
        const dto = {
          visitId: rowData.id,
          firstName: payload.firstName,
          lastName: payload.lastName,
          purposeTypeId: payload.purposeTypeId.id,
          visitorTypeId: payload.visitorTypeId.id,
          hostId: payload.hostId ? payload.hostId : selectedHost.id,
          phoneCountryCode: !CommonUtil.isEmpty(payload.phoneNumber)
            ? payload.phoneCountryCode
            : "",
          phoneNumber: payload.phoneNumber,
          scheduledStartDate: CommonUtil.formatLocalDateTime(
            payload.scheduledStartDate,
          ),
          scheduledEndDate: CommonUtil.formatLocalDateTime(
            payload.scheduledEndDate,
          ),
          emailId: payload.emailId,
          visitMode: payload.visitMode,
          visitorCompanyName: payload.visitorCompanyName,
          siteId: payload.siteId.id,
          siteTimeZone: payload.siteTimeZone,
          documentNumber: payload.documentNumber,
          documentExpireDate: payload.documentExpireDate,
          remarks: payload.remarks,
          approvalReason: payload.approvalReason,
          documentFrontImage: payload.documentFrontImage,
          documentRearImage: payload.documentRearImage,
          profilePhoto: payload.firstName,
          verifyTypeIn: payload.verifyTypeIn,
          invitationScan: payload.invitationScan,
          walkInScan: payload.walkInScan,
          selfScan: payload.selfScan,
          printerImage: printerImage,
          documentIssuedDate: payload.documentIssuedDate,
          documentScanMode: documentScanMode,
          objectKeys: objectKeys,
          offenderFound: offenderFound,
          offenderData: offenderDataList,
          offenderMatch: payload.offenderMatch,
        };

        dispatch(updatePreRegistration(dto))
          .unwrap()
          .then((data) => {
            if (data.code === "MSGS4000") {
              const result = data.data || {};
              if (confirmationBypass === true && result.dymoLabel != null) {
                print(result.dymoLabel);
              }
              if (result.currentVisitCount !== undefined) {
                setCurrentTotalVisitCount(result.currentVisitCount);
              }
              if (!CommonUtil.isEmptyString(result.profilePhotoURL)) {
                uploadProfilePhoto(data);
              }
              Toast(t("PRE_REGISTRATION_UPDATE"), "success");
              if (props.onSaved) {
                props.onSaved();
              }
              handleClose(false);
            } else {
              onError(data);
            }
          });
      } else {
        Toast(t("INVITATIONFORM003"), "error");
      }
    }
    clearData();
  };

  const titleStyle = {
    color: "#242424",
    opacity: 1,
  };

  useEffect(() => {
    setInavalidprofilePhoto(false);
    loadData(props.open);
  }, []);

  useEffect(() => {
    if (dlScannerPermission) startSentinelSession();
  }, [dlScannerPermission]);

  const loadData = () => {
    loadEmployees();
    loadSites();
    loadVisitorType();
    loadPurposeType();
    loadUser();
    loadCompany();
    loadSetting();
  };

  const loadUser = () => {
    dispatch(getUserInfoPro(decoded_jwtToken.userId))
      .unwrap()
      .then((data) => {
        if (data.code === "UASI0000" || data.code === "UASI0033") {
          setUserPhone(data.data.phone);
        }
      })
      .catch((er) => {});
  };

  const loadVisitorType = () => {
    const query = {
      page: 1,
      rowsPerPage: 1000,
      name: "",
      status: "ACTIVE",
    };

    dispatch(getAllVisitorType(query))
      .unwrap()
      .then((data) => {
        if (data.code === "CVAI0000") {
          setVisitorData(data.data.visitorTypes);
        } else {
          setVisitorData([]);
        }
      })
      .catch((e) => {
        console.log(e);
      });
  };

  const loadPurposeType = () => {
    const query = {
      page: 1,
      rowsPerPage: 1000,
      name: "",
      status: "ACTIVE",
    };

    dispatch(getPurposeType(query))
      .unwrap()
      .then((data) => {
        if (data.code === "CVAI0000") {
          setPurposeData(data.data.purposeTypes);
          setDateChange(true);
        } else {
          setPurposeData([]);
        }
      })
      .catch((e) => {
        console.log(e);
      });
  };

  const formatDate = (dateFormat) => {
    switch (dateFormat) {
      case "dd-MM-yyyy":
        return "dd-MM-yyyy HH:mm";
      case "MM-dd-yyyy":
        return "MM-dd-yyyy HH:mm";
      case "yyyy-MM-dd":
        return "yyyy-MM-dd HH:mm";
      default:
        return "yyyy-MM-dd HH:mm";
    }
  };

  const toPickerDate = (value) => {
    if (!value) return null;
    const parsed = moment(value);
    return parsed.isValid() ? parsed.toDate() : null;
  };

  const loadSetting = () => {
    dispatch(getListSettings())
      .unwrap()
      .then((data) => {
        setPayload((prev) => ({
          ...prev,
          verifyTypeIn: data.data.walkInRegistartionVerifyMode,
          walkInScan: data.data.walkInScanLimit,
        }));
        setConfirmationBypass(data.data.badgePrint);
        setWalkInImageCapture(data.data.walkInImageCapture);
        setDateFormat(formatDate(data.data.dateFormat));
      });
  };

  const loadEmployees = (event) => {
    const config = {
      headers: { companyId: localStorage.getItem("companyId") },
    };
    httpCommon
      .unsecuredAxios()
      .get(
        "/web/selfRegistartion/employees/list?sort=createdAt%7Cdesc&caseSensitive=true&operator=AND&pageNumber=1&pageSize=50",
        config,
      )
      .then((data) => {
        if (data.data.code === "OMSI0000") {
          setHostList(data.data.data.employees);
        } else {
          getSelectedItem();
          setHostList([]);
        }
      });
  };
  useEffect(() => {
    const defaultHost = hostList.find((host) => host.id === payload.hostId);
    if (defaultHost?.id) {
      setSelectHost(defaultHost);
      setPayload({
        ...payload,
        hostId: defaultHost.id,
      });
    }
  }, [payload.hostId, hostList]);

  const getSelectedItem = (newValue) => {
    if (newValue != null) {
      setPayload({
        ...payload,
        hostId: newValue.id,
      });
      setSelectHost(newValue);
    } else {
      setPayload({
        ...payload,
        hostId: "",
      });
      setSelectHost({});
    }
  };
  const loadSites = () => {
    const query = {
      page: 1,
      rowsPerPage: 10000,
      name: "",
    };
    dispatch(getAllSites(query))
      .unwrap()
      .then((data) => {
        if (data.code === "LMSI0000") {
          setSiteData(data.data.site);
        } else {
          setSiteData([]);
        }
      });
  };

  const loadCompany = () => {
    dispatch(getCompanyInfo())
      .unwrap()
      .then((data) => {
        if ((data.code = "UASI0026")) {
          const fullCountryName = data.data.country;
          const countryCode = getCountryCodeFromName(fullCountryName);
          if (countryCode) {
            setCountry(countryCode);
          } else {
            setCountry("us");
          }
        }
      })
      .catch((er) => {});
  };
  const getCountryCodeFromName = (countryName) => {
    const formattedCountryName = countryName
      .toLowerCase()
      .replace(/\b\w/g, (l) => l.toUpperCase());
    const countryCode = (
      isoCountries.getAlpha2Code(formattedCountryName, "en") || ""
    ).toLowerCase();
    return countryCode || null;
  };

  const filterOptions = createFilterOptions({
    stringify: ({ firstName, email }) => `${firstName} ${email}`,
    limit: 1,
  });

  const [setPrivacy, setitPrivacy] = useState(false);
  const [confirmationBypass, setConfirmationBypass] = useState(false);

  const handleChange = (event) => {
    const name = event.target.name;
    setPayload({
      ...payload,
      [name]: event.target.value,
    });
    setitPrivacy(event.target.checked);
    setError({
      [name]: false,
    });
  };

  const handlePhoneChange = (value, data, event, formattedValue) => {
    setPhoneInput(value);
    setPayload({
      ...payload,
      phoneCountryCode: "+" + data.dialCode,
      phoneNumber: value.toString().replace(data.dialCode, ""),
    });
    setError({ phoneNumber: false });
  };

  const onselectVisitorType = (event) => {
    setPayload({
      ...payload,
      visitorTypeId: event,
    });
  };

  const onselectPurposeType = (event) => {
    setPayload({
      ...payload,
      purposeTypeId: event,
    });
  };

  const setImageFromCam = (image) => {
    if (profilePhotoToggle) {
      setPrinterImage(image);
    }
  };

  const [dlScanner, setDlScanner] = useState(false);
  const [passport, setPassport] = useState(false);
  const [resetTrigger, setResetTrigger] = useState(0);

  const [validatedPhoto, setValidatedPhoto] = useState(false);

  const handleProfile = (file) => {
    setValidatedPhoto(false);
    if (file) {
      const formData = new FormData();
      formData.append("visitorImageFile", file);
      dispatch(validateVisitorImage(formData)).then((res) => {
        if (!res?.payload?.data?.image) {
          setValidatedPhoto(true);
          Toast(t("FACE_DETECTION_ERROR"), "error");
          setProfileImage(null);
          setdlImage(null);
          setImageFromCam("");
          setResetTrigger(Date.now());
          return;
        }
      });
    }
    setValidatedPhoto(false);

    setPayload({
      ...payload,
      profilePhoto: payload?.firstName,
    });
    setProfileImage(validatedPhoto ? "" : file);
    setdlImage(validatedPhoto ? "" : file);
  };

  const handleAddAssets = () => {
    if (objectKeys.length >= props.walkImageCaptureLimit) {
      Toast(t("IMAGE_LIMIT"), "error");
      return;
    }
    let payload = {
      fileName: "VISITOR_ASSET" + assetsImages.length + 1,
      scope: "Application",
      applicationName: "MSGP",
      companyId: localStorage.getItem("companyId"),
    };

    dispatch(uploadVisitorAsset(payload))
      .unwrap()
      .then((res) => {
        if (res.code === "MSGS4042" && res.data) {
          setAssetUploadData(res.data);
          setWebCam(!webCam);
          setObjectKeys((prevData) => [...prevData, res.data.objectKey]);
        } else {
          Toast(res.message, "error");
        }
      });
  };

  const handleDeleteAsset = (index) => {
    let objectKey = objectKeys.filter((_, i) => i == index);
    let payload = {
      fileName: "",
      scope: "",
      applicationName: "",
      companyId: "",
      objectKeys: objectKey,
    };
    dispatch(deteleAssetImage(payload))
      .unwrap()
      .then((res) => {
        if (res.code === "MSGS4043") {
          Toast(t("REMOVE_ASSET_IMAGE"), "success");
          let newImages = assetsImages.filter((_, i) => i !== index);
          setAssetsImages(newImages);
          let newObjectKeys = objectKeys.filter((_, i) => i !== index);
          setObjectKeys(newObjectKeys);
        } else {
          Toast(res.message, "error");
        }
      });
  };

  const handleWithOutCaptureImage = () => {
    const index = objectKeys.length - 1;
    let objectKey = objectKeys.filter((_, i) => i == index);
    let payload = {
      fileName: "",
      scope: "",
      applicationName: "",
      companyId: "",
      objectKeys: objectKey,
    };
    dispatch(deteleAssetImage(payload))
      .unwrap()
      .then((res) => {
        if (res.code === "MSGS4043") {
          let newImages = assetsImages.filter((_, i) => i !== index);
          setAssetsImages(newImages);
          let newObjectKeys = objectKeys.filter((_, i) => i !== index);
          setObjectKeys(newObjectKeys);
        } else {
          Toast(res.message, "error");
        }
      });
  };

  const [value, setValue] = React.useState("manualEntry");
  const [webCampPermssion, setWebCampPermission] = useState(false);
  const handleChangeTabs = (event, newValue) => {
    setValue(newValue);
  };

  const [scannedDocument, setScannedDocument] = useState();
  const [dlNameMismatch, setDlNameMismatch] = useState(null);
  const [cancellingVisit, setCancellingVisit] = useState(false);
  const sentinelGUID = "eb18e024-22b0-4df0-af18-9cea21942756";

  const startSentinelSession = () => {
    axios.post("http://localhost:10300/sentinel/v1/session/" + sentinelGUID);
  };

  const getScannedData = async () => {
    try {
      const endPoint2 =
        "http://localhost:10300/sentinel/v1/session/" +
        sentinelGUID +
        "/document?api_key=v2";

      const res = await axios.get(endPoint2);

      if (res.data === "") {
        Toast(t("WALKINREPORTLBLDLSCAN"), "info");
        setDlScanner(false);
        return;
      }

      setDocumentScanMode("DOCUMENT_SCANNER_MODE");
      processScannedData(res.data);
      setDisableOffender(false);
    } catch (error) {
      console.error("Error fetching scanned data:", error);
      Toast(t("WALKINREPORTLBLDLSCANERROR"), "info");
    }
  };

  const offenderAuthorizationKey = "AIzaSyDGpRrhZbiHQZnuMyCNUyuNhEKPjzCXgOE";
  const [offenders, setOffenders] = useState([]);
  const [offenderFound, setOffenderFound] = useState(false);
  const [offenderNotFound, setOffenderNotFound] = useState(false);
  const [backGroundVerified, setBackGroundVerified] = useState(false);
  const [disableOffender, setDisableOffender] = useState(true);
  const handleOffenderCheck = () => {
    setDisableOffender(true);
    setBackGroundVerified(true);
    setLoading(true);
    const options = { method: "GET", headers: { accept: "application/json" } };
    fetch(
      "https://api.offenders.io/sexoffender/?key=" +
        offenderAuthorizationKey +
        "&firstName=" +
        payload.firstName +
        "&lastName=" +
        payload.lastName +
        "&dob=" +
        payload.dateOfBirth,
      options,
    )
      .then((response) => response.json())
      .then((response) => {
        console.log(response);
        setOffenders(response);
        if (response.offenders.length > 0) {
          setOffenderFound(true);
          setOffenderData(response.offenders[0]);
          setOffenderDataList(response.offenders);
        } else {
          setOffenderNotFound(true);
          setOffenderDataList([]);
        }
      })
      .catch((err) => console.error(err));

    setLoading(false);
  };

  useEffect(() => {
    setDocumentScanMode(documentScanMode);
  }, [documentScanMode]);

  const processScannedData = (data) => {
    setDlScanner(true);
    if (
      !data.Document ||
      !data.Document.DocumentInfo ||
      !data.Document.DocumentInfo.ClassName ||
      data.Document.DocumentInfo.ClassName === "Unknown"
    ) {
      Toast(t("PASSPORT_VALIDATION"), "error");
      return;
    }

    setPassport(
      data.Document.DocumentInfo.ClassName === "Passport" ? true : false,
    );
    setPayload({
      ...payload,
      documentFrontImage:
        "data:image/jpeg;base64," +
        data.Document.Images["Image-Array"][0].DocumentImage.Bitmap[
          "image byte array"
        ],
      documentRearImage:
        "data:image/jpeg;base64," +
        data.Document.Images["Image-Array"][1].DocumentImage.Bitmap[
          "image byte array"
        ],
    });

    // Photo is applied (and validated via /web/visit/validate-photo) only after
    // the name check passes, or when the user accepts the DL name.
    var dlPhoto = "";
    data.Document.Regions["Region-Array"].map((item) => {
      if (item.DocumentRegion.Name === "Photo") {
        dlPhoto =
          item.DocumentRegion["Image-Bitmap"].Bitmap["image byte array"];
      }
    });
    var dateOfBirth = "";
    var documentNumber = "";
    var firstName = "";
    var lastName = "";
    var documentExpireDate = "";
    var address = "";
    var documentIssuedDate = "";
    var documentFrontImage = "";
    var documentRearImage = "";
    var documentFrontImage =
      data.Document.DocumentInfo.ClassName === "Passport"
        ? data.Document.Images["Image-Array"][1].DocumentImage.Bitmap[
            "image byte array"
          ]
        : data.Document.Images["Image-Array"][0].DocumentImage.Bitmap[
            "image byte array"
          ];
    var documentRearImage =
      data.Document.DocumentInfo.ClassName === "Passport"
        ? ""
        : data.Document.Images["Image-Array"][1].DocumentImage.Bitmap[
            "image byte array"
          ];

    data.Document.Fields["Field-Array"].map((item) => {
      if (item.DocumentField.Name === "Document Number") {
        documentNumber = item.DocumentField.Value;
      }
      if (item.DocumentField.Name === "Full Name") {
        let name = item.DocumentField.Value;
        let nameParts = name
          .trim()
          .split(" ")
          .filter(Boolean);
        if (nameParts.length === 1) {
          firstName = nameParts[0];
        } else if (nameParts.length === 2) {
          firstName = nameParts[0];
          lastName = nameParts[1];
        } else {
          lastName = nameParts[nameParts.length - 1];
          firstName = nameParts.slice(0, -1).join(" ");
        }
      }

      if (item.DocumentField.Name === "Expiration Date") {
        documentExpireDate = item.DocumentField.Value.split("T")[0];
        let currentDate = new Date().toISOString().split("T")[0];
        if (documentExpireDate < currentDate) {
          Toast("Document Expired", "error");
          return;
        }
      }

      if (item.DocumentField.Name === "Issue Date") {
        documentIssuedDate = item.DocumentField.Value.split("T")[0];
      }

      if (item.DocumentField.Name === "Address") {
        address = item.DocumentField.Value;
      }
      if (item.DocumentField.Name === "Birth Date") {
        dateOfBirth = item.DocumentField.Value.split("T")[0];
      }
    });
    const normalize = (value) => (value || "").trim().toLowerCase();
    const hasExistingName = normalize(payload.firstName) !== "";
    const isNameMismatch =
      hasExistingName &&
      normalize(firstName) !== "" &&
      (normalize(payload.firstName) !== normalize(firstName) ||
        normalize(payload.lastName) !== normalize(lastName));

    if (!isNameMismatch && dlPhoto) {
      applyDlPhoto(dlPhoto);
    }

    setPayload({
      ...payload,
      documentNumber: documentNumber,
      firstName: isNameMismatch || !firstName ? payload.firstName : firstName,
      lastName: isNameMismatch || !firstName ? payload.lastName : lastName,
      documentExpireDate: documentExpireDate,
      address: address,
      documentIssuedDate: documentIssuedDate,
      documentFrontImage: documentCapturePermission ? documentFrontImage : "",
      documentRearImage: documentCapturePermission ? documentRearImage : "",
      dateOfBirth: dateOfBirth,
    });
    setScannedDocument(data);
    if (isNameMismatch) {
      setDlNameMismatch({ firstName, lastName, photo: dlPhoto });
    }
  };

  const applyDlPhoto = (photo) => {
    handleProfile(b64toBlob(photo, "image/jpeg"));
    setProfileImage("data:image/jpeg;base64," + photo);
    if (profilePhotoToggle) {
      setPrinterImage(photo);
    }
  };

  const handleUseDlName = () => {
    if (dlNameMismatch.photo) {
      applyDlPhoto(dlNameMismatch.photo);
    }
    setPayload((prev) => ({
      ...prev,
      firstName: dlNameMismatch.firstName,
      lastName: dlNameMismatch.lastName,
    }));
    setDlNameMismatch(null);
  };

  const handleCancelVisitOnNameMismatch = () => {
    setCancellingVisit(true);
    dispatch(rejectVisitorPreRegistrationInvite({ id: rowData.id }))
      .unwrap()
      .then((data) => {
        if (data.code === "MSGS4000") {
          Toast(t("PRE_REGISTRATION_REJECT"), "success");
          setDlNameMismatch(null);
          if (props.onSaved) {
            props.onSaved();
          }
          handleClose(false);
        } else {
          Toast(data.message, "error");
        }
      })
      .catch((error) => {
        Toast(error?.message || "Something went wrong.", "error");
      })
      .finally(() => setCancellingVisit(false));
  };

  const clearData = () => {
    axios
      .delete("http://localhost:10300/sentinel/v1/session/" + sentinelGUID)
      .then((res) => {
        console.log(res);
      });
  };

  const purposeTypeToggle = companySettings.walkInRegistrationPurposeType;
  const visitorTypeToggle = companySettings.walkInRegistrationVisitorType;
  const companyNameToggle = companySettings.wlakInRegistrationCompanyName;
  const siteTypeToggle = companySettings.walkInRegistrationSiteType;
  const profilePhotoToggle = companySettings.walkInRegistrationProfilePhoto;
  const purposeTypeMandatory =
    companySettings.checkWalkInRegistrationPurposeType;
  const visitorTypeMandatory =
    companySettings.checkWalkInRegistrationVisitorType;
  const companyNameMandatory =
    companySettings.checkWalkInRegistrationCompanyName;
  const profilePhotoMandatory =
    companySettings.checkWalkInRegistrationProfilePhoto;

  const webCamEnableOrDisable = profilePhotoToggle || documentCapturePermission;

  useEffect(() => {
    if (darkMode) {
      document.body.classList.add("darkMode");
    } else {
      document.body.classList.remove("darkMode");
    }
    return () => {
      document.body.classList.remove("darkMode");
    };
  }, [darkMode]);

  const handleOptionSelected = (event, value) => {
    if (value) {
      getSelectedItem(value);
      setSelectHost(value);
    } else {
      getSelectedItem();
      setSelectHost();
    }
  };

  const handleInputChange = (event, newInputValue) => {
    setSearchTerm(newInputValue.replace(/\s\s+/g, " "));
  };

  return (
    <>
      <Dialog
        className={classes.dialogbox}
        open={open}
        fullWidth={true}
        maxWidth={"md"}
        disableBackdropClick
        disableEscapeKeyDown
        BackdropProps={{
          style: {
            backdropFilter: "blur(5px)",
            // Adjust the opacity as needed
          },
        }}
      >
        <DialogTitle
          variant="h4"
          style={{
            backgroundColor: darkMode ? "#0E2A41" : "#fff",
            color: darkMode ? "#fff" : "black",
          }}
        >
          <IconButton
            aria-label="close"
            onClick={handleClose}
            sx={{
              position: "absolute",
              right: 15,
              top: 8,
              color: (theme) => theme.palette.grey[500],
            }}
          >
            <CloseIcon />
          </IconButton>
          {t("PRE_REGISTRATION_EDIT")}
        </DialogTitle>
        <Divider
          variant="middle"
          style={{
            background: darkMode
              ? "transparent linear-gradient(90deg, rgba(190, 231, 255, 0.05) 0%, rgba(34, 107, 171, 0.5) 47%, rgba(190, 231, 255, 0.05) 100%) 0% 0% no-repeat padding-box"
              : "transparent linear-gradient(90deg, rgba(190, 231, 255, 0.05) 0%, rgba(34, 107, 171, 0.5) 47%, rgba(190, 231, 255, 0.05) 100%) 0% 0% no-repeat padding-box",
            height: "1px",
            opacity: 0.5,
          }}
        />

        <DialogContent
          style={{ backgroundColor: darkMode ? "#0E2A41" : "#fff" }}
        >
          <Grid container justifyContent="center">
            {loading && (
              <Box sx={{ display: "flex" }} className="loader-container">
                <CircularProgress className="loader" />
              </Box>
            )}
            {webCamEnableOrDisable ? (
              <Grid
                xs={12}
                sm={4}
                container
                justifyContent="center"
                style={{ width: "100%", padding: "45px, 0px" }}
                direction="column"
                alignItems="center"
              >
                {dlScanner ? (
                  <img
                    src={profileImage}
                    alt="Profile"
                    style={{
                      borderStyle: "dashed ",
                      borderRadius: "50%",
                      padding: "5px",
                      color: "#D2D2D2",
                      height: "200px",
                      width: "220px",
                    }}
                    onClick={() => setDlScanner(false)}
                  />
                ) : (
                  <>
                    <WebcamCapture
                      onsetProfile={(profile) => handleProfile(profile)}
                      profilePhoto={profileImage}
                      base64Image={(data) => setImageFromCam(data)}
                      resetTrigger={resetTrigger}
                    />
                  </>
                )}
              </Grid>
            ) : null}

            <Grid
              item
              md={8}
              container
              justifyContent="center"
              style={{ width: "100%" }}
            >
              <Grid item sm={12}>
                <TabContext value={value}>
                  <Box sx={{ margin: "20px 0px 0 2px" }}>
                    <TabList
                      onChange={handleChangeTabs}
                      aria-label="lab API tabs example"
                      centered
                      style={{
                        boxShadow: "none",
                        backgroundColor: "transparent",
                        width: "519px",
                        marginLeft: "17px",
                        borderRadius: "10px",
                      }}
                      indicatorColor="none"
                    >
                      <Tab
                        label={t("WALKINREPORTLBLMANUAL")}
                        value="manualEntry"
                        className={darkMode ? "tabStyleReg1" : "tabStyleReg"}
                        style={{ width: "50%" }}
                      />
                      {dlScannerPermission ? (
                        <Tab
                          label={t("WALKINREPORTLBLSCANLICENCE")}
                          value="scanLicense"
                          className={darkMode ? "tabStyleReg1" : "tabStyleReg"}
                          style={{ width: "50%" }}
                        />
                      ) : (
                        ""
                      )}
                    </TabList>
                    <TabPanel
                      value="manualEntry"
                      style={{
                        paddingBottom: "0px",
                      }}
                    >
                      <Grid container sm={12} columnSpacing={2} rowSpacing={3}>
                        <Grid item lg={6} sm={12}>
                          <CustomTextfield
                            label={t("COMMON020")}
                            error={error.firstName}
                            name="firstName"
                            value={payload.firstName}
                            handleChange={(e) => handleChange(e)}
                            helperText={error.firstName}
                            required={true}
                            autoComplete="off"
                            inputProps={{ className: classes.input }}
                          />
                        </Grid>

                        <Grid item lg={6} sm={12}>
                          <CustomTextfield
                            label={t("COMMON021")}
                            error={error.lastName}
                            name="lastName"
                            value={payload.lastName}
                            handleChange={(e) => handleChange(e)}
                            helperText={error.lastName}
                            autoComplete="off"
                            inputProps={{ className: classes.input }}
                          />
                        </Grid>

                        {scannedDocument ? (
                          <Grid item lg={6} sm={12}>
                            <CustomTextfield
                              label={passport ? "DL/Passport No" : "DL No"}
                              error={error.documentNumber}
                              name="documentNumber"
                              value={payload.documentNumber}
                              handleChange={(e) => handleChange(e)}
                              disabled
                            />
                          </Grid>
                        ) : null}

                        {scannedDocument ? (
                          <Grid item lg={6} sm={12}>
                            <CustomTextfield
                              label={"Expired Date *"}
                              error={error.documentExpireDate}
                              name="documentExpireDate"
                              value={payload.documentExpireDate}
                              handleChange={(e) => handleChange(e)}
                              disabled
                            />
                          </Grid>
                        ) : null}

                        <Grid item lg={6} sm={12}>
                          <CustomTextfield
                            label={t("COMMON042")}
                            error={error.emailId}
                            name="emailId"
                            value={payload.emailId}
                            handleChange={(e) => handleChange(e)}
                            helperText={error.emailId}
                            validation="email"
                            autoComplete="off"
                            inputProps={{ className: classes.input }}
                          />
                        </Grid>

                        <Grid item lg={6} sm={12}>
                          <CustomPhones
                            placeholder={t("COMMON063")}
                            value={phoneInput}
                            specialLabel={false}
                            country={country}
                            handleChange={(
                              value,
                              data,
                              event,
                              formattedValue,
                            ) =>
                              handlePhoneChange(
                                value,
                                data,
                                event,
                                formattedValue,
                              )
                            }
                            inputProps={{ className: classes.input }}
                          />
                        </Grid>

                        {purposeTypeToggle && (
                          <Grid item lg={6} sm={12}>
                            <Autocomplete
                              popupIcon={<ExpandMoreIcon />}
                              sx={{
                                width: "100%",
                              }}
                              noOptionsText={"No Options found"}
                              name="purposeTypeId"
                              value={payload.purposeTypeId}
                              options={
                                CommonUtil.isEmptyArray(purposeData)
                                  ? []
                                  : purposeData
                              }
                              getOptionLabel={(option) =>
                                option.name ? option.name : ""
                              }
                              onChange={(event, newValue) => {
                                if (!CommonUtil.isEmpty(newValue)) {
                                  onselectPurposeType(newValue);
                                } else {
                                  onselectPurposeType("");
                                }
                                setError({ purposeTypeId: false });
                              }}
                              renderInput={(params) => (
                                <TextField
                                  {...params}
                                  required={purposeTypeMandatory ? true : false}
                                  name="purposeTypeId"
                                  value={payload.purposeTypeId}
                                  error={error.purposeTypeId}
                                  variant="outlined"
                                  fullWidth
                                  label={t("PURPOSELABEL1")}
                                />
                              )}
                            />
                          </Grid>
                        )}

                        {visitorTypeToggle && (
                          <Grid item lg={6} sm={12}>
                            <Autocomplete
                              popupIcon={<ExpandMoreIcon />}
                              sx={{}}
                              noOptionsText={"No Options found"}
                              name="visitorTypeId"
                              value={payload.visitorTypeId}
                              options={
                                CommonUtil.isEmptyArray(visitorData)
                                  ? []
                                  : visitorData
                              }
                              getOptionLabel={(option) =>
                                option.name ? option.name : ""
                              }
                              onChange={(event, newValue) => {
                                if (!CommonUtil.isEmpty(newValue)) {
                                  onselectVisitorType(newValue);
                                } else {
                                  onselectVisitorType("");
                                }
                                setError({ visitorTypeId: false });
                              }}
                              renderInput={(params) => (
                                <TextField
                                  {...params}
                                  name="visitorTypeId"
                                  required={visitorTypeMandatory ? true : false}
                                  value={payload.visitorTypeId}
                                  error={error.visitorTypeId}
                                  variant="outlined"
                                  fullWidth
                                  label={t("COMMON068")}
                                />
                              )}
                            />
                          </Grid>
                        )}

                        <Grid item lg={6} sm={12}>
                          <Autocomplete
                            popupIcon={<ExpandMoreIcon />}
                            sx={{
                              color: "#242424",
                              "& .MuiAutocomplete-clearIndicator": {
                                color: "#949596",
                              },
                              "& .MuiSvgIcon-root": {
                                color: "#949596",
                              },
                            }}
                            id="free-solo-demo"
                            freeSolo
                            noOptionsText={"No Options found"}
                            fullWidth
                            value={selectedHost}
                            filterOptions={filterOptions}
                            onChange={(event, newValue) => {
                              handleOptionSelected(event, newValue);
                              setError({ selectedHost: false });
                            }}
                            inputValue={searchTerm}
                            onInputChange={handleInputChange}
                            options={hostList}
                            disabled={decoded_jwtToken.roleName === "Employee"}
                            // filterOptions={filterOptions}
                            getOptionLabel={(option) =>
                              option.lastName
                                ? option.firstName + " " + option.lastName
                                : option.firstName
                                ? option.firstName
                                : ""
                            }
                            renderInput={(params) => (
                              <CustomTextfield
                                {...params}
                                name="hostId"
                                label={t("commonsTextFeildHost")}
                                placeholder={t("commonsTextFeildHost")}
                                error={error.selectedHost}
                              />
                            )}
                          />
                        </Grid>

                        {companyNameToggle && (
                          <Grid item lg={6} xs={12}>
                            <CustomTextfield
                              required={companyNameMandatory ? true : false}
                              label={t("VISUPDATE0006")}
                              error={error.visitorCompanyName}
                              name="visitorCompanyName"
                              value={payload.visitorCompanyName}
                              handleChange={(e) => handleChange(e)}
                              helperText={error.visitorCompanyName}
                              inputProps={{ className: classes.input }}
                            />
                          </Grid>
                        )}

                        <Grid item lg={6} sm={12}>
                          <Autocomplete
                            popupIcon={<ExpandMoreIcon />}
                            sx={{ width: "100%" }}
                            noOptionsText={"No Options found"}
                            name="siteId"
                            disabled={true}
                            value={payload.siteId}
                            options={
                              CommonUtil.isEmptyArray(siteData) ? [] : siteData
                            }
                            getOptionLabel={(option) =>
                              option.name ? option.name : ""
                            }
                            renderInput={(params) => (
                              <TextField
                                {...params}
                                name="siteId"
                                required={true}
                                error={error.siteId}
                                variant="outlined"
                                fullWidth
                                label={t("SITE013")}
                                disabled
                              />
                            )}
                          />
                        </Grid>
                        <Grid item lg={6} xs={12}>
                          <CustomDateTimePicker
                            onChange={(scheduledStartDate) => {
                              if (!moment(scheduledStartDate).isValid()) return;
                              setPayload({
                                ...payload,
                                scheduledStartDate: CommonUtil.formatLocalDateTime(
                                  scheduledStartDate,
                                ),
                                scheduledEndDate: CommonUtil.formatLocalDateTime(
                                  moment(scheduledStartDate).add(
                                    walkInIntervalTime,
                                    "minutes",
                                  ),
                                ),
                              });
                              setError({ scheduledStartDate: false });
                            }}
                            value={toPickerDate(payload.scheduledStartDate)}
                            // Site time: no past times; early check-in is validated by the backend
                            // (no disablePast: it uses the PC clock, not site time)
                            minDateTime={getSiteNow()}
                            error={!!error.scheduledStartDate}
                            label={"Invite Start Date"}
                            date={dateFormat || formatDate()}
                          />
                        </Grid>

                        <Grid item lg={6} xs={12}>
                          <CustomDateTimePicker
                            onChange={(scheduledEndDate) => {
                              if (!moment(scheduledEndDate).isValid()) return;
                              setPayload({
                                ...payload,
                                scheduledEndDate: CommonUtil.formatLocalDateTime(
                                  scheduledEndDate,
                                ),
                              });
                              setError({ scheduledEndDate: false });
                            }}
                            value={toPickerDate(payload.scheduledEndDate)}
                            minDateTime={
                              toPickerDate(payload.scheduledStartDate) ||
                              getSiteNow()
                            }
                            error={!!error.scheduledEndDate}
                            label="Invite End Date"
                            date={dateFormat || formatDate()}
                          />
                        </Grid>

                        {scannedDocument ? (
                          <Grid item lg={6} xs={12}>
                            <CustomTextfield
                              label="Address"
                              error={error.address}
                              name="address"
                              value={payload.address}
                              handleChange={(e) => handleChange(e)}
                              helperText={error.address}
                              validation="alphabets"
                              inputProps={{ className: classes.input }}
                            />
                          </Grid>
                        ) : null}

                        {scannedDocument ? (
                          <Grid
                            item
                            lg={
                              (Number(!purposeTypeToggle) +
                                Number(!visitorTypeToggle) +
                                Number(!companyNameToggle) +
                                Number(!siteTypeToggle)) %
                                2 ===
                              1
                                ? 6
                                : 12
                            }
                            sm={12}
                          >
                            <CustomTextfield
                              label={t("COMMON016")}
                              error={error.remarks}
                              name="remarks"
                              value={payload.remarks}
                              validation="restrictLength"
                              handleChange={(e) => handleChange(e)}
                              helperText={error.remarks}
                              inputProps={{
                                maxLength: 100,
                                className: classes.input,
                              }}
                            />
                          </Grid>
                        ) : (
                          <Grid
                            item
                            lg={
                              (Number(!purposeTypeToggle) +
                                Number(!visitorTypeToggle) +
                                Number(!companyNameToggle) +
                                Number(!siteTypeToggle)) %
                                2 ===
                              1
                                ? 12
                                : 6
                            }
                            sm={12}
                          >
                            <CustomTextfield
                              label={t("COMMON016")}
                              error={error.remarks}
                              name="remarks"
                              value={payload.remarks}
                              handleChange={(e) => handleChange(e)}
                              validation="restrictLength"
                              helperText={error.remarks}
                              inputProps={{
                                maxLength: 100,
                                className: classes.input,
                              }}
                            />
                          </Grid>
                        )}
                        <Grid
                          item
                          xs={12}
                          sm={12}
                          md={12}
                          lg={12}
                          xl={12}
                          spacing={3}
                          style={{
                            width: "100%",
                            display: "flex",
                            justifyContent: "flex-start",
                            columnGap: "15px",
                          }}
                        >
                          {assetsImages.map((imageSrc, index) => (
                            <div
                              key={index}
                              style={{ position: "relative" }}
                              onMouseEnter={() => setHoveredIndex(index)}
                              onMouseLeave={() => setHoveredIndex(null)}
                            >
                              <img
                                key={index}
                                src={imageSrc}
                                alt={`Image ${index + 1}`}
                                height="60"
                                width="60"
                              />

                              {hoveredIndex === index && (
                                <Tooltip title={t("REMOVE_ASSET")}>
                                  <CloseIcon
                                    key={index}
                                    style={{
                                      position: "absolute",
                                      right: "-10px",
                                      top: "-10px",
                                      backgroundColor: "#DDDDDD",
                                      borderRadius: "50px",
                                      height: "17px",
                                      width: "17px",
                                    }}
                                    onClick={() => handleDeleteAsset(index)}
                                  />
                                </Tooltip>
                              )}
                            </div>
                          ))}
                          {walkInImageCapture && assetsImages.length < 5 && (
                            <Tooltip title={t("ADD_ASSET")}>
                              <img
                                src={cameraIcon}
                                alt="Invalid Icon"
                                onClick={handleAddAssets}
                                height="30"
                                width="30"
                              />
                            </Tooltip>
                          )}
                        </Grid>
                      </Grid>

                      <DialogActions
                        style={{
                          justifyContent: "center",
                        }}
                      >
                        <CancelButtons
                          variant="contained"
                          color="secondary"
                          onClick={handleClose}
                        >
                          <Typography
                            variant="body1"
                            style={{ textTransform: "none" }}
                          >
                            {t("INVITATION003")}
                          </Typography>
                        </CancelButtons>
                        <SubmitButtons
                          variant="contained"
                          onClick={handleSubmit}
                        >
                          <Typography
                            variant="body1"
                            style={{ textTransform: "none" }}
                          >
                            {t("COMMON035")}
                          </Typography>
                        </SubmitButtons>
                      </DialogActions>
                    </TabPanel>

                    {dlScannerPermission && (
                      <TabPanel value="scanLicense">
                        {props.showDLScan ? (
                          <Grid
                            style={{ textAlign: "end", marginRight: "10px" }}
                          >
                            {payload.documentFrontImage !== "" ? (
                              <SubmitButtons
                                variant="contained"
                                disabled
                                onClick={() => {
                                  getScannedData();
                                }}
                              >
                                <Typography
                                  variant="body1"
                                  style={{ textTransform: "none" }}
                                >
                                  {t("WALKINREPORTLBLDL")}
                                </Typography>
                              </SubmitButtons>
                            ) : (
                              <SubmitButtons
                                variant="contained"
                                onClick={() => {
                                  getScannedData();
                                }}
                                style={{ height: "44px" }}
                              >
                                <Typography
                                  variant="body1"
                                  style={{ textTransform: "none" }}
                                >
                                  {t("WALKINREPORTLBLDL")}
                                </Typography>
                              </SubmitButtons>
                            )}
                          </Grid>
                        ) : (
                          ""
                        )}
                        <Grid
                          container
                          sm={12}
                          spacing={1}
                          style={{ paddingTop: "11px" }}
                        >
                          {documentCapturePermission && (
                            <Grid item lg={6} sm={12}>
                              <UploadDocs
                                imageName={t("WALKINREPORTLBLCAPT")}
                                profilePhoto={
                                  scannedDocument
                                    ? passport
                                      ? "data:image/jpeg;base64," +
                                        scannedDocument.Document.Images[
                                          "Image-Array"
                                        ][1].DocumentImage.Bitmap[
                                          "image byte array"
                                        ]
                                      : "data:image/jpeg;base64," +
                                        scannedDocument.Document.Images[
                                          "Image-Array"
                                        ][0].DocumentImage.Bitmap[
                                          "image byte array"
                                        ]
                                    : ""
                                }
                              />
                            </Grid>
                          )}

                          <Grid item lg={6} sm={12}>
                            {documentCapturePermission && !passport && (
                              <UploadDocs
                                imageName={t("WALKINREPORTLBLCAPTBCK")}
                                profilePhoto={
                                  scannedDocument
                                    ? "data:image/jpeg;base64," +
                                      scannedDocument.Document.Images[
                                        "Image-Array"
                                      ][1].DocumentImage.Bitmap[
                                        "image byte array"
                                      ]
                                    : ""
                                }
                              />
                            )}
                          </Grid>

                          {documentCapturePermission &&
                            offenderFeature &&
                            offenderVerification && (
                              <Grid
                                style={{
                                  padding: "6px",
                                }}
                              >
                                <SubmitButtons
                                  disabled={
                                    disableOffender ||
                                    payload.documentFrontImage === ""
                                  }
                                  variant="contained"
                                  onClick={() => {
                                    handleOffenderCheck();
                                  }}
                                >
                                  <Typography
                                    variant="body1"
                                    style={{
                                      textTransform: "none",
                                      color: darkMode
                                        ? "rgb(205, 205, 205)"
                                        : "",
                                    }}
                                  >
                                    {t("OFFENDER")}
                                  </Typography>
                                </SubmitButtons>
                              </Grid>
                            )}
                          {backGroundVerified && (
                            <Grid
                              item
                              xs={12}
                              sm={12}
                              md={12}
                              lg={12}
                              xl={12}
                              style={{
                                height: "60px",
                                width: "100%",
                                backgroundColor: "#e6ffe6",
                                borderRadius: "10px",
                                marginTop: "10px",
                              }}
                            >
                              <Stack
                                direction="row"
                                spacing={2}
                                style={{
                                  display: "inline-flex",
                                  justifyContent: "center",
                                  alignItems: "center",
                                }}
                              >
                                <img
                                  src={successIcon}
                                  alt="success"
                                  style={{
                                    marginLeft: "15px",
                                    marginTop: "8px",
                                  }}
                                />
                                <Typography
                                  style={{
                                    color: "#6BC88E",
                                    marginTop: "10px",
                                  }}
                                >
                                  Background Verified
                                </Typography>
                              </Stack>
                            </Grid>
                          )}
                          {offenderNotFound && (
                            <Grid
                              item
                              xs={12}
                              sm={12}
                              md={12}
                              lg={12}
                              xl={12}
                              style={{
                                height: "60px",
                                width: "100%",
                                backgroundColor: "#e6ffe6",
                                borderRadius: "10px",
                                marginTop: "10px",
                              }}
                            >
                              <Stack
                                direction="row"
                                spacing={2}
                                style={{
                                  display: "inline-flex",
                                  justifyContent: "center",
                                  alignItems: "center",
                                }}
                              >
                                <img
                                  src={successIcon}
                                  alt="success"
                                  style={{
                                    marginLeft: "15px",
                                    marginTop: "8px",
                                  }}
                                />
                                <Typography
                                  style={{
                                    color: "#6BC88E",
                                    marginTop: "10px",
                                  }}
                                >
                                  No Offender Record Found
                                </Typography>
                              </Stack>
                            </Grid>
                          )}
                          {offenderFound && (
                            <Grid
                              item
                              xs={12}
                              sm={12}
                              md={12}
                              lg={12}
                              xl={12}
                              style={{
                                height: "60px",
                                width: "100%",
                                backgroundColor: "#FFEAEB",
                                borderRadius: "10px",
                                marginTop: "10px",
                              }}
                            >
                              <Stack
                                direction="row"
                                spacing={2}
                                style={{
                                  display: "inline-flex",
                                  justifyContent: "center",
                                  alignItems: "center",
                                }}
                              >
                                <img
                                  src={errorIcon}
                                  alt="success"
                                  style={{
                                    marginLeft: "15px",
                                    marginTop: "8px",
                                  }}
                                />
                                <Typography
                                  style={{
                                    color: "#FF4D50",
                                    marginTop: "10px",
                                  }}
                                >
                                  Offender Record Found
                                </Typography>
                              </Stack>
                            </Grid>
                          )}
                        </Grid>
                        <DialogActions
                          style={{
                            justifyContent: "flex-end",
                          }}
                        >
                          <SubmitButtons
                            variant="contained"
                            onClick={() => {
                              if (documentCapturePermission) {
                                if (!payload.documentFrontImage) {
                                  Toast(t("DOCUMENT_SCANNER_ERROR"), "error");
                                  return;
                                }
                                if (!passport && !payload.documentRearImage) {
                                  Toast(t("DOCUMENT_SCANNER_ERROR"), "error");
                                  return;
                                }
                              }
                              setValue("manualEntry");
                            }}
                          >
                            <Typography
                              variant="body1"
                              style={{ textTransform: "none" }}
                            >
                              {t("VERIFYCOMP0003")}
                            </Typography>
                          </SubmitButtons>
                        </DialogActions>
                      </TabPanel>
                    )}
                  </Box>
                </TabContext>
              </Grid>
            </Grid>
          </Grid>
        </DialogContent>
        {webCam && (
          <VisitorAssetsDialog
            open={webCam}
            handleClose={() => {
              handleWithOutCaptureImage();
              setWebCam(!webCam);
            }}
            content={assetuploadData}
            handleSubmit={(blob, base64Data, content) => {
              setAssetsImages((prevImages) => [...prevImages, base64Data]);
              uploadAssetImages(blob);
              setWebCam(!webCam);
              Toast(t("ASSET_SUCCESSFULLY"), "success");
            }}
          />
        )}
        {offenderFound && (
          <Offender
            visitorDLData={offenderData}
            visitorDLImage={profileImage}
            data={offenderData}
            open={offenderFound}
            handleMatch={() => {
              setPayload({
                ...payload,
                offenderMatch: true,
              });
              setOffenderFound(false);
            }}
            handleCloseMatch={() => {
              setPayload({
                ...payload,
                offenderMatch: false,
              });
              setOffenderFound(false);
            }}
          />
        )}
        {dlNameMismatch && (
          <Dialog
            open={true}
            disableEscapeKeyDown
            PaperProps={{
              sx: {
                width: 450,
                maxWidth: "calc(100% - 32px)",
                borderRadius: "8px",
                backgroundColor: darkMode ? "#0E2A41" : "#fff",
                boxShadow: "0px 3px 20px rgba(0, 0, 0, 0.16)",
              },
            }}
          >
            <Box sx={{ px: 2.5, pt: 3 }}>
              <Typography
                sx={{
                  fontSize: "18px",
                  fontWeight: 500,
                  color: darkMode ? "#fff" : "#242424",
                }}
              >
                {t("DL_NAME_MISMATCH_TITLE")}
              </Typography>
              <Divider
                sx={{
                  mt: 2.5,
                  mx: 2.5,
                  borderColor: darkMode ? "#1F4A6B" : "#EBEBEB",
                }}
              />
            </Box>
            <Box sx={{ px: 5, pt: 4, pb: 3.5, textAlign: "center" }}>
              <Typography
                sx={{
                  fontSize: "16px",
                  lineHeight: "28px",
                  color: darkMode ? "#fff" : "#474B4F",
                }}
              >
                {/* {t("DL_NAME_MISMATCH_HELLO")}{" "} */}
                <Box
                  component="span"
                  sx={{ color: darkMode ? "#7DB8E8" : "#1B5C94" }}
                >
                  {/* {`${payload.firstName || ""} ${payload.lastName ||
                    ""}`.trim()} */}
                </Box>
                {t("DL_NAME_MISMATCH_MESSAGE")}
              </Typography>
            </Box>
            <Stack
              direction="row"
              justifyContent="center"
              spacing={2.5}
              sx={{ px: 2.5, pb: 3.75 }}
            >
              <CancelButtons
                variant="contained"
                color="secondary"
                onClick={handleCancelVisitOnNameMismatch}
              >
                <Typography variant="body1" style={{ textTransform: "none" }}>
                  {t("DL_NAME_REJECT")}
                </Typography>
              </CancelButtons>
              <SubmitButtons variant="contained" onClick={handleUseDlName}>
                <Typography variant="body1" style={{ textTransform: "none" }}>
                  {t("DL_NAME_ACCEPT")}
                </Typography>
              </SubmitButtons>
            </Stack>
          </Dialog>
        )}
      </Dialog>
    </>
  );
}
